module.exports = __webpack_public_path__ + "static/media/dummy_profile.190d3c5c.webp";